import { render, staticRenderFns } from "./ConvoyAssociaSigilli.vue?vue&type=template&id=535eb75a&scoped=true"
import script from "./ConvoyAssociaSigilli.vue?vue&type=script&lang=js"
export * from "./ConvoyAssociaSigilli.vue?vue&type=script&lang=js"
import style0 from "./ConvoyAssociaSigilli.vue?vue&type=style&index=0&id=535eb75a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "535eb75a",
  null
  
)

export default component.exports